import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'

/**
 * Strategy Action Type Constants
 * @type {string}
 */
export const GET_CONTACT_STRATEGY_REQUEST = 'GET_CONTACT_STRATEGY_REQUEST'
export const GET_CONTACT_STRATEGY_SUCCESS = 'GET_CONTACT_STRATEGY_SUCCESS'
export const GET_CONTACT_STRATEGY_FAILURE = 'GET_CONTACT_STRATEGY_FAILURE'

export const UPDATE_CONTACT_STRATEGY_REQUEST = 'UPDATE_CONTACT_STRATEGY_REQUEST'
export const UPDATE_CONTACT_STRATEGY_SUCCESS = 'UPDATE_CONTACT_STRATEGY_SUCCESS'
export const UPDATE_CONTACT_STRATEGY_FAILURE = 'UPDATE_CONTACT_STRATEGY_FAILURE'

/**
 * Get Contact Strategy
 * @param contactId
 * @param options
 * @private
 */
const _getContactStrategy = (contactId, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      GET_CONTACT_STRATEGY_REQUEST,
      GET_CONTACT_STRATEGY_SUCCESS,
      GET_CONTACT_STRATEGY_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: `/contact/${contactId}/strategy`
  }
})

/**
 * Update Contact Strategy
 * @param contactId
 * @param data
 * @returns {{}}
 * @private
 */
const _updateContactStrategy = (contactId, data) => ({
  [CALL_API]: {
    types: [
      UPDATE_CONTACT_STRATEGY_REQUEST,
      UPDATE_CONTACT_STRATEGY_SUCCESS,
      UPDATE_CONTACT_STRATEGY_FAILURE
    ],
    method: METHOD_TYPE.PUT,
    endpoint: `/contact/${contactId}/strategy`,
    payload: data
  }
})

/**
 * Dispatch GET_CONTACT_STRATEGY_REQUEST
 * @param id
 * @param options
 * @param options.types - action types
 */
export const getContactStrategy = (id, options) => (dispatch) => {
  return dispatch(_getContactStrategy(id, options))
}

/**
 * Dispatch UPDATE_CONTACT_STRATEGY_REQUEST
 * @param id
 * @param data
 */
export const updateContactStrategy = (id, data) => (dispatch) => {
  return dispatch(_updateContactStrategy(id, data))
}
